const DiaryEntryRecipe = {
    $type$: 'Recipe',
    name: 'DiaryEntry',
    rule: [
        {
            itemprop: 'entry',
            itemtype: { type: 'string' }
        },
        {
            itemprop: 'text',
            itemtype: { type: 'string' },
            optional: true
        },
        {
            itemprop: 'mood',
            itemtype: { type: 'string' },
            optional: true
        },
        {
            itemprop: 'patientId',
            itemtype: { type: 'string' },
            optional: true
        }
    ]
};
const DiaryRecipes = [DiaryEntryRecipe];
export default DiaryRecipes;
//# sourceMappingURL=DiaryRecipes.js.map